"use client";
import { ark } from "../factory.js";
import { useCheckboxContext } from "./use-checkbox-context.js";
import { forwardRef } from "react";
import { mergeProps } from "@zag-js/react";
import { jsx } from "react/jsx-runtime";
//#region src/components/checkbox/checkbox-indicator.tsx
var CheckboxIndicator = forwardRef((props, ref) => {
	const { indeterminate, ...rest } = props;
	const checkbox = useCheckboxContext();
	const mergedProps = mergeProps(checkbox.getIndicatorProps(), rest);
	const isVisible = indeterminate ? checkbox.indeterminate : checkbox.checked;
	return /* @__PURE__ */ jsx(ark.div, {
		...mergedProps,
		hidden: !isVisible,
		ref
	});
});
CheckboxIndicator.displayName = "CheckboxIndicator";
//#endregion
export { CheckboxIndicator };
